import { useQuery } from "@tanstack/react-query";
import { api } from "../../api-client";
import { queryKeys } from "../query-keys";

interface ClubsDiscoveryParams {
	q?: string;
	page?: number;
	type?: string;
	is_public?: boolean;
}

interface ExploreClubsParams {
	q?: string;
	page?: number;
	ranked_for?: string;
	explain?: boolean;
}

export function useClubsFriends(params?: ClubsDiscoveryParams) {
	return useQuery({
		queryKey: queryKeys.clubs.friends(params as Record<string, unknown>),
		queryFn: () => api.clubs.friends(params),
	});
}

export function useExploreClubs(params?: ExploreClubsParams) {
	return useQuery({
		queryKey: queryKeys.explore.clubs(params as Record<string, unknown>),
		queryFn: () => api.explore.clubs(params),
	});
}
